import { createContext, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useDispatch, useSelector } from 'react-redux';
import { client } from '../helpers/api/apiCall';
import { setToken, setUser } from '../store/slices/auth';
import { Endpoints } from '../utils/Endpoints';

const JWTContext = createContext(null);

export const JWTProvider = ({ children }) => {
    const authState = useSelector((state) => state.auth);

    const verifyToken = (serviceToken) => {
        if (!serviceToken) {
            return false;
        }
        const decoded = jwtDecode(serviceToken);

        return decoded.exp > Date.now() / 1000;
    };

    const dispatch = useDispatch();
    useEffect(() => {
        const init = async () => {
            try {
                const serviceToken = authState.token;
                if (serviceToken && verifyToken(serviceToken)) {
                    const decoded = jwtDecode(serviceToken);
                    const emailAddress = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
                    const nameIdentifier = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];
                    const userData = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"];
                    const name = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];


                    if (decoded) {
                        dispatch(setUser({ email: emailAddress, adName: nameIdentifier, personelNo: userData, fullName: name }))
                    } else {
                        dispatch(setUser({}))
                    }

                } else {

                }
            } catch (err) {
                console.error(err);

            }
        };

        init();
    }, [authState.token]);

    const login = async (userIdentifier, password) => {
        const response = await client.post(Endpoints.IDENTITY.TOKEN, { userIdentifier, password });
        const { success, payload } = response.data;
        if (success && payload) {
            dispatch(setToken(payload))
        } else {
            dispatch(setToken(''))
            dispatch(setUser({}))
        }
    };


    const loginWithOtp = async (phone, otpCode) => {
        const response = await client.post(Endpoints.IDENTITY.VERIFY_OTP, { phone, otpCode });
        const { success, payload } = response.data;
        if (success && payload) {
            dispatch(setToken(payload))
        } else {
            dispatch(setToken(''))
            dispatch(setUser({}))
        }
    };

    const logout = () => {
        dispatch(setToken(''))
        dispatch(setUser({}))
    };

    return (
        <JWTContext.Provider value={{ login, logout, loginWithOtp }}>{children}</JWTContext.Provider>
    );
};

export default JWTContext;